/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

import Header from "./header";
import "./layout.css";
import { APPS } from "./config";

const Layout = ({ children, countryCode, logoMaxWidth }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      {countryCode && (
        <Header
          siteTitle={data.site.siteMetadata.title}
          countryCode={countryCode}
          logoMaxWidth={logoMaxWidth}
        />
      )}
      <div
        className="py-8 md:py-16"
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          paddingTop: 0,
        }}
      >
        <main>{children}</main>
        {countryCode && (
          <footer className="text-white text-center p-8">
            © {new Date().getFullYear()}, {APPS[countryCode].appName}
          </footer>
        )}
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
